import { Link, useNavigate } from "react-router-dom";
import GLOBAL from "../Common/Util";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { Disclaimer, TermsAndCondition } from "./Agreement";

export function SignInTitle({title, name, url}) {
    return (
        <>
            <span class="h2">{title} </span> <span class="h6">/ <Link to={url} class="text-decoration-none">{name}</Link></span>
        </>
    );
}

export default function Title({title, urlcallback}) {
    const navigate = useNavigate();

    const handleBack = (event) => {
        if(urlcallback===null || urlcallback===undefined) {
            setTimeout(() => {
            navigate('/', { replace: true });
            }, 100);
        } else {
            urlcallback();
        }
      }
    
    
    return (
        <>
            <span class="h2"><button type="button" class="btn btn-outline-secondary border-0 rounded-circle p-1 ps-2 pe-2" onClick={()=>handleBack()}>&#129128;</button>{title}</span>
        </>
    );
}

export function Message({msg}) {
    return (
        <>
          <div class="h6 mt-1 small text-center text-danger" dangerouslySetInnerHTML={{__html: msg}}></div>
        </>
    );
}

export function EmailMobile({reference, data, callback}) {
    return (
        <div class="mb-2 mt-1">
            <label for="email">Email / Mobile * :</label>
            <input type="input" maxlength="50" class="form-control" id="email" ref={reference} placeholder="Enter email/mobile" name="email" value={data} onChange={callback} />
        </div>
    );
}

export function Pin({reference, data, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    return (
        <>
        <div class="mt-2">
            <label for="pin">Pin * :</label>
        </div>
        <div class="input-group mb-2 ">
            <input type={showPassword ? 'text' : 'password'} maxlength="15" class="form-control" id="pin" ref={reference} placeholder="Enter pin" name="pin" value={data} onChange={callback} />
            <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
            </span>
        </div>
        </>
    );
}

export function Password({reference, data, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    
    return (
        <>
        <div class="">
            <label for="password">Password * :</label>
        </div>
        <div class="input-group mb-2 ">
            <input type={showPassword ? 'text' : 'password'} maxlength="20" class="form-control" id="password" ref={reference} placeholder="Enter password" name="password" value={data} onChange={callback} />
            <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
            </span>
        </div>
        </>
    );
}

export function FirstNameLastName({title, firstnamereference, lastnamereference, firstvalue, lastvalue, callback}) {
    return (
        <>
            <div class="mt-1">
                <label for={title}>{title}:</label>
            </div>
            <div class="input-group mb-2 ">
                <input type="input" maxlength="50" class="form-control" id="firstName" ref={firstnamereference} placeholder="First Name" name="firstName" value={firstvalue} onChange={callback} />
                <input type="input" maxlength="50" class="form-control" id="lastName" ref={lastnamereference} placeholder="Last Name" name="lastName" value={lastvalue} onChange={callback} />
            </div>
        </>
    );
}

export function Email({reference, data, callback}) {
    return (
        <div class="mb-2 mt-2">
            <label for="email">Email * :</label>
            <input type="input" maxlength="50" class="form-control" id="email" ref={reference} placeholder="Enter email" name="email" value={data} onChange={callback} />
        </div>
    );
}

export function Mobile({reference, data, callback}) {
    return (
        <div class="mb-2 mt-2">
            <label for="mobile" title="min:10 digit, max:15 digit">Mobile * :</label>
            <input type="input" maxlength="15" class="form-control" id="mobile" ref={reference} placeholder="Enter mobile" name="mobile" value={data} onChange={callback} />
        </div>
    );
}

export function ConfirmPassword({reference, confirmreference, value, confirmvalue, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    return (
        <>
          <div class="mt-2">
              <label for="password" title="min: 8, max:20, required: 1 char, 1 digit, 1 cap, 1 special char">Password * :</label>
          </div>  
          <div class="input-group mb-2 ">
              <input type="password" maxlength="20" class="form-control" id="password" ref={reference} placeholder="Enter password" name="password" value={value} onChange={callback}/>
              <input type={showPassword ? 'text' : 'password'} maxlength="20" class="form-control" id="confirmpassword" ref={confirmreference} placeholder="Confirm password" name="confirmpassword" value={confirmvalue} onChange={callback}/>
              <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
              </span>
          </div>
        </>
    );
}

export function ConfirmPin({reference, confirmreference, value, confirmvalue, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    return (
        <>
          <div class="mt-2">
              <label for="password" title="min: 6 digit, max: 15 digit">Pin * :</label>
          </div>  
          <div class="input-group mb-2 ">
              <input type="password" maxlength="15" class="form-control" id="pin" ref={reference} placeholder="Enter pin" name="pin" value={value} onChange={callback}/>
              <input type={showPassword ? 'text' : 'password'} maxlength="15" class="form-control" id="confirmpin" ref={confirmreference} placeholder="Confirm pin" name="confirmpin" value={confirmvalue} onChange={callback}/>
              <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
              </span>
          </div>
        </>
    );
}

export function OTP({reference, data, callback}) {
    return (
        <div class="mb-2">
            <label for="otp">OTP * :</label>
            <input type="password" maxlength="20" class="form-control" id="otp" ref={reference} placeholder="Enter otp" name="otp" value={data} onChange={callback} />
        </div>
    );
}

export function TermsCheckBox({reference, isChecked, callback}) {
    const [showTerm, setShowTerm] = useState(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    
    const handleTermClose = () => setShowTerm(false);
    const handleTermShow = () => setShowTerm(true);
    const handleDisclaimerClose = () => setShowDisclaimer(false);
    const handleDisclaimerShow = () => setShowDisclaimer(true);

    return (
        <div class="form-check mb-0 mt-0 pt-0">
            <input class="form-check-input" type="checkbox" ref={reference} value="" id="term" checked={isChecked} onChange={callback} />
            <label class="form-check-label" for="term">
                I read and understood the <Link onClick={handleTermShow}>terms & condition</Link> and <Link onClick={handleDisclaimerShow}>disclaimer</Link>
            </label>
            <Modal centered backdrop="static" show={showTerm} onHide={handleTermClose} scrollable={true}>
                <Modal.Header closeButton>
                <Modal.Title>Terms and Conditions</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <TermsAndCondition/>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>

            <Modal centered backdrop="static" show={showDisclaimer} onHide={handleDisclaimerClose} scrollable={true}>
                <Modal.Header closeButton>
                <Modal.Title>Disclaimer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Disclaimer/>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export function SubmitClearButton({callback}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            {
                GLOBAL.isLoading===true?(
                <>
                    <button type="submit" class="btn btn-primary " disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Submit
                    </button>
                    <button type="button" class="btn btn-primary " onClick={callback} disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Clear
                    </button>
                </>
                ):(
                <>
                    <button type="submit" class="btn btn-primary " >Submit</button>
                    <button type="button" class="btn btn-primary " onClick={callback}>Clear</button>
                </>
                )
            }
        </div>
    );
}

export function SingleButton({title,callback}) {
    const navigate = useNavigate();

    const handleBack = (event) => {
        if(callback===null || callback===undefined) {
            setTimeout(() => {
            navigate('/', { replace: true });
            }, 100);
        } else {
            callback();
        }
      }

    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            {
                GLOBAL.isLoading===true?(
                <>
                    <button type="button" class="btn btn-primary " onClick={()=>handleBack()} disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {title}
                    </button>
                </>
                ):(
                <>
                    <button type="button" class="btn btn-primary " onClick={()=>handleBack()}>{title}</button>
                </>
                )
            }
        </div>
    );
}


